import { type ReactNode } from 'react';
import { ResumeFunnelButton } from '@hungryroot/funnel';
import { Tag, X } from '@hungryroot/icons';
import {
  Button,
  NativeDialogWrapper,
  TransparentButton,
} from '@hungryroot/ramen';
import { useGetPromoData, useGetFormattedPromo } from '@hungryroot/rest-hooks';
import styles from './MobileMenu.module.css';

type Props = {
  isOpen: boolean;
  onDismiss: () => void;
  navLinks: ReactNode;
};

export function MobileMenu({ isOpen, onDismiss, navLinks }: Props) {
  const { data: promoData } = useGetPromoData();
  const promoText = useGetFormattedPromo(styles.bold, promoData);

  return (
    <NativeDialogWrapper
      ariaLabel="Mobile Menu"
      size="full-screen"
      isOpen={isOpen}
      onDismiss={onDismiss}
      containerClassName={styles.container}
      bodyClassName={styles.body}
    >
      <header className={styles.header}>
        <TransparentButton
          onClick={onDismiss}
          ariaLabel="Close menu"
          className={styles.close}
        >
          <X className={styles['close-icon']} />
        </TransparentButton>
      </header>
      {navLinks}
      <footer className={styles.footer}>
        <div className={styles['promo-container']}>
          <Tag />
          {promoText}
        </div>
        <ResumeFunnelButton
          startQuizText="Get started"
          style="success"
          prominence="primary"
          size="medium"
          className={styles['quiz-cta']}
        />
        <Button
          buttonType="link"
          to="/login"
          textPrimary="Login"
          style="default"
          prominence="tertiary-underlined"
          size="medium"
          className={styles['login-cta']}
        />
      </footer>
    </NativeDialogWrapper>
  );
}
